<div class="table-responsive">
  <a class="btn btn-outline-primary mb-3" (click)="onBackToWinLoseDetail()">
    <i class="bi bi-chevron-left"></i> {{'PREVIOUS_PAGE' | translate}}
  </a>
  <button class="btn btn-outline-primary mb-3 float-end" (click)="getBetDetail()">
    <i class="bi bi-arrow-clockwise"></i> refresh
  </button>
  <span class="d-block">
    BET ID : {{ betId }}
    <span class="float-end">{{'ALL_LISTS' | translate}} {{ data.length || 0 }} {{'LIST' | translate}}</span>
  </span>
  <table class="table table-hover text-nowrap">
    <thead>
      <tr>
        <th rowspan="2">#</th>
        <th rowspan="2">Info</th>
        <th rowspan="2">Action</th>
        <th>Game/Provider</th>
        <th>Game Datail</th>
        <th>End Round</th>
        <th>Free Round</th>
        <th>Status</th>
        <th>Bet Type</th>
        <th>Amount</th>
        <th>W/L</th>
        <th rowspan="2">Before Credit</th>
        <th rowspan="2">After Credit</th>
      </tr>
      <tr>
        <th colspan="6">Total</th>
        <th class="text-end fw-bold">{{ summary.amount | number : "1.2-2" }}</th>
        <th class="text-end fw-bold">
          <span [ngClass]="{ 'text-danger': summary.wl < 0, 'text-primary': summary.wl > 0 }">{{
            summary.wl | number : "1.2-2"
            }}</span>
          <div class="d-block badge badge-secondary text-end mt-2 mb-2">
            <span class="float-start">bonus</span>
            {{ summary.bonus | number : "1.2-2" }}
          </div>
          <span [ngClass]="{
              'text-danger': summary.wl + summary.bonus < 0,
              'text-primary': summary.wl + summary.bonus > 0
            }">
            {{ summary.wl + summary.bonus | number : "1.2-2" }}
          </span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of data; let i = index">
        <td>{{ i + 1 }}</td>
        <td class="text-start">
          <i class="bi bi-circle-fill" [ngStyle]="{ color: '#' + getColorRoundId(item) }"></i>
          txnId : {{ item.txnId }}
          <small class="d-block opacity-50"> roundId : {{ item.roundId }} </small>
          <small class="d-block opacity-50">
            {{ item.timestamp | date : "dd/MM/yy HH:mm:ss" }}
          </small>
          <div class="text-end" *ngIf="isAdmin || isSuperAdmin">
            <hr class="my-1" />
            <a class="link-danger" (click)="fixMakeBetCancel(item)">
              <small><i class="bi bi-x-circle"></i> {{'CANCEL_BET' | translate}}</small>
            </a>
          </div>
        </td>
        <td>W/L</td>
        <td class="text-start">
          {{'GAME_NAME' | translate}} : {{ item.game_name }}
          <ng-container *ngIf="item.info"> ({{ item.info }}) </ng-container>
          <small class="d-block opacity-50"> {{'GAME_PROVIDER' | translate}} : {{ item.product_id }} </small>
          <small class="d-block opacity-50">
            {{ item.platform }}
          </small>
        </td>
        <td>
          <a type="button" data-bs-toggle="offcanvas" data-bs-target="#betReplay" aria-controls="offcanvasRight"
            (click)="getReplay(item)">
            <strong><u>Bet Detail</u></strong>
          </a>
        </td>
        <td>
          <ng-container *ngIf="item.isEndRound">
            <span class="badge badge-success"> success </span>
          </ng-container>
          <ng-container *ngIf="!item.isEndRound">
            <span class="badge badge-warning">
              <img src="assets/loading-gif.gif" width="10px" alt /> running
            </span>
          </ng-container>
        </td>
        <td>
          <ng-container *ngIf="item.isFreeRound"> YES </ng-container>
          <ng-container *ngIf="!item.isFreeRound"> NO </ng-container>
        </td>
        <td>{{ item.status }}</td>
        <td>
          <ng-container *ngIf="item.betType">
            <span *ngIf="item.betType">{{ item.betType }}</span>
          </ng-container>
          <ng-container *ngIf="!item.betType"> - </ng-container>
        </td>
        <td class="text-end fw-bold">{{ item.betAmount | number : "1.2-2" }}</td>
        <td class="text-end fw-bold" [ngClass]="{
            'text-danger': item.winloseAmount < 0,
            'text-primary': item.winloseAmount > 0
          }">
          <u>{{ item.winloseAmount | number : "1.2-2" }}</u>
        </td>
        <td class="text-end fw-bold">
          {{ item.balanceBefore | number : "1.2-2" }}
        </td>
        <td class="text-end fw-bold">
          <u>{{ item.balanceAfter | number : "1.2-2" }}</u>
        </td>
      </tr>
      <tr>
        <td colspan="9">Total</td>
        <td class="text-end fw-bold">{{ summary.amount | number : "1.2-2" }}</td>
        <td class="text-end fw-bold" [ngClass]="{ 'text-danger': summary.wl < 0, 'text-primary': summary.wl > 0 }">
          {{ summary.wl | number : "1.2-2" }}
          <div class="d-block badge badge-secondary text-end mt-2 mb-2">
            <span class="float-start">bonus</span>
            {{ summary.bonus | number : "1.2-2" }}
          </div>
          {{ summary.wl + summary.bonus | number : "1.2-2" }}
        </td>
        <td colspan="2"></td>
      </tr>
    </tbody>
  </table>
</div>

<div class="text-center mb-3">
  <div class *ngIf="data && !data.length">{{ "NO_DATA" | translate }}</div>
  <div *ngIf="loadingWinlose"><span class="spinner-border"></span></div>
</div>

<div class="offcanvas offcanvas-end" tabindex="-1" id="betReplay" aria-labelledby="offcanvasRightLabel">
  <div class="offcanvas-header">
    <h5 id="offcanvasRightLabel">Bet Replay : {{ tnxtId }}</h5>
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
    <iframe *ngIf="url" [src]="url" style="width: 100%; height: 90vh" frameborder="0"></iframe>
  </div>
</div>
